module.exports = __webpack_public_path__ + "static/img/li1_15.dbe371ce.png";